export const comments_3359079 = {"data":{"data":[],"links":{}}}